<template lang="html">
  <div>
    <header class="main-header" v-if="usuarioLogado.basic && usuarioLogado.basic.idUsuario">
      <!-- Logo -->
      <a
        class="sidebar-toggle sidebar-left-side"
        data-toggle="offcanvas"
        href="#"
        role="button"
        v-show="usuarioLogado.basic && usuarioLogado.basic.idUsuario"
        @click.prevent="toggleMenu()"
      >
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </a>
      <a
        class="logo"
        data-toggle="offcanvas"
        href="#"
        role="button"
        :class="{ hidden: isMenuToggled }"
        @click.prevent="toggleMenu()"
      >
        <transition
          name="bounce"
          enter-active-class="bounceInLeft animated"
          leave-active-class="bounceOutLeft animated"
        >
          <span class="logo-lg ncm-helper text-center"> <strong>NCM</strong>Helper </span>
        </transition>
      </a>
      <nav class="navbar navbar-static-top my-nav">
        <!-- Sidebar toggle button-->
        <a
          class="sidebar-toggle sidebar-min-width"
          data-toggle="offcanvas"
          href="#"
          role="button"
          v-show="usuarioLogado.basic && usuarioLogado.basic.idUsuario"
          @click.prevent="toggleMenu()"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </a>
        <transition
          name="bounce"
          enter-active-class="bounceInLeft animated"
          leave-active-class="bounceOutLeft animated"
        >
          <div class="search-on-top" :class="colSetSearch">
            <selecao-empresa
              v-if="usuarioLogado.basic && usuarioLogado.basic.idUsuario"
            ></selecao-empresa>
          </div>
        </transition>
        <ul
          class="nav navbar-nav"
          :style="
            `cursor: pointer; padding: 5px 10px 0 0; margin-left: -${setPosEmpresaPendencias}px;`
          "
        >
          <li class="dropdown">
            <empresa-pendencias
              type="small"
              v-if="empresaSelecionada.id && usuarioLogado.departament.idDepartamento !== 2"
              :circle="true"
              :value="empresaSelecionada"
              link-title="Detalhes da empresa"
              @on-click="openModalDetalhes"
            />
          </li>
        </ul>
        <span
          class="ellipsis small-screen"
          :class="colSetInfoEmpresa"
          v-if="Object.keys(empresaSelecionada).length"
          style="padding: 0; margin-top: 4px;"
        >
          <span class="pull-left">
            ID: <b>{{ empresaSelecionada.id }} - </b> ID Domínio:
            <b
              >{{
                empresaSelecionada.idSistemaFolha > 0
                  ? empresaSelecionada.idSistemaFolha
                  : 'Não cadastrado'
              }}
              -
            </b>
            <span
              style="cursor: pointer;"
              v-btn-clipboard
              :data-clipboard-text="empresaSelecionada.cnpj"
            >
              <i class="fa fa-address-card-o" />
              {{ empresaSelecionada.cnpj | cpfCnpj }}
            </span>
          </span>
          <br />
          <small
            style="cursor: pointer;"
            v-btn-clipboard
            :data-clipboard-text="empresaSelecionada.razaoSocial"
          >
            <i class="fa fa-bank" />
            {{ empresaSelecionada.razaoSocial }}
          </small>
        </span>

        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav" v-show="usuarioLogado.basic && usuarioLogado.basic.idUsuario">
            <li class="dropdown notifications-menu">
              <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                <i
                  :class="{
                    'fa fa-bell': notifications.length,
                    'fa fa-bell-o': !notifications.length
                  }"
                ></i>
                <span class="label label-danger" v-if="notifications.length">{{
                  notifications.length
                }}</span>
              </a>
              <ul class="dropdown-menu">
                <li class="header">Você tem {{ notifications.length }} notificações</li>
                <li>
                  <ul class="menu">
                    <li v-for="notification in notifications">
                      <a class="quebra" href="#" @click.prevent="removeNotification(notification)">
                        {{ notification }}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <!-- Fila de processos -->
            <the-queue />
            <li class="dropdown user user-menu">
              <a class="dropdown-toggle user-info" data-toggle="dropdown" href="#">
                <img class="user-image" src="../assets/logo.png" alt="User Image" />
                <span class="hidden-xs user"
                  >{{ usuarioLogado.basic.nome | shortName }}
                  <small><nivel-label :value="usuarioLogado.level.idNivel"/></small>
                </span>
              </a>
              <ul class="dropdown-menu">
                <!-- User image -->
                <li class="user-header">
                  <img class="img-circle" src="../assets/logo.png" alt="User Image" />

                  <p>
                    {{ usuarioLogado.basic.nome | shortName }}
                    <small><nivel-label :value="usuarioLogado.level.idNivel"/></small>
                    <!-- <small>Membro desde: {{usuarioLogado.dtCadastro | date}}</small> -->
                  </p>
                </li>
                <!-- Menu Footer-->
                <li class="user-footer">
                  <div class="pull-right">
                    <a class="btn btn-default btn-flat" href="#" v-on:click.prevent="logout()">
                      <i class="fa fa-sign-out"></i>
                      Sair
                    </a>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <modal
      v-if="modalDetalhes"
      @close="modalDetalhes = !modalDetalhes"
      :show-footer="false"
      classes="modal-lg"
    >
      <div slot="modal-title">
        <h3>Detalhes da empresa</h3>
      </div>
      <div slot="modal-body">
        <empresa-detalhes />
      </div>
    </modal>
  </div>
</template>

<script>
import Popover from '../components/Popover.vue'
import TheQueue from '../components/TheQueue/TheQueue'
import Multiselect from 'vue-multiselect'
import NivelLabel from './NivelLabel'
import EmpresaDetalhes from '../app/Empresas/EmpresaDetalhes.vue'
import EmpresaPendencias from '../app/Empresas/EmpresaPendencias.vue'
import Modal from './Modal.vue'
import SelecaoEmpresa from './SelecaoEmpresa.vue'
import Permissions from '../models/Permissions'

export default {
  name: 'main-header',
  data() {
    return {
      permissions: Permissions,
      empresas: [],
      modalDetalhes: false,
      expand: false,
      windowWidth: 0,
      colSetSearch: '',
      colSetInfoEmpresa: '',
      setPosEmpresaPendencias: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowHeight)
      this.getWindowHeight()
    })

    this.verificaUser()

    // Inicializar funcionalidades do AdminLTE
    this.$nextTick(() => {
      if (window.$ && window.$.AdminLTE) {
        // Inicializar os componentes do AdminLTE
        window.$('[data-toggle="offcanvas"]').click(function() {
          // O evento já está sendo tratado pelo Vue, então apenas prevenimos o comportamento padrão
          return false
        })
      }
    })
  },
  methods: {
    getWindowHeight(event) {
      this.windowWidth = document.documentElement.clientWidth
      if (this.windowWidth < 1750) {
        this.colSetSearch = 'col-sm-2'
        this.colSetInfoEmpresa = 'col-sm-4'
        this.setPosEmpresaPendencias = '30'
      } else {
        this.colSetSearch = 'col-sm-3'
        this.colSetInfoEmpresa = 'col-sm-3'
        this.setPosEmpresaPendencias = '60'
      }
    },
    verificaUser() {
      let body = document.querySelector('body')
      if (this.usuarioLogado.basic && this.usuarioLogado.basic.idUsuario) {
        // Remove classes desnecessárias e adiciona as classes do AdminLTE
        body.className = body.className
          .split(' ')
          .filter(c => c !== 'login-page')
          .join(' ')

        // Adiciona as classes necessárias se não existirem
        if (!body.classList.contains('skin-blue')) {
          body.classList.add('skin-blue')
        }
        if (!body.classList.contains('sidebar-mini')) {
          body.classList.add('sidebar-mini')
        }
      } else {
        body.className = 'login-page'
      }
    },

    toggleMenu(state = null) {
      const body = document.querySelector('body')

      if (state === null) {
        // Toggle automático
        if (body.classList.contains('sidebar-collapse')) {
          body.classList.remove('sidebar-collapse')
          this.$store.dispatch('setMenu', false)
        } else {
          body.classList.add('sidebar-collapse')
          this.$store.dispatch('setMenu', true)
        }
      } else {
        // Estado específico
        if (state) {
          body.classList.add('sidebar-collapse')
          this.$store.dispatch('setMenu', true)
        } else {
          body.classList.remove('sidebar-collapse')
          this.$store.dispatch('setMenu', false)
        }
      }
    },

    removeNotification(notification) {
      this.$store.dispatch('removeNotification', notification)
    },

    logout() {
      this.$store.dispatch('setUser', {})
      this.$store.dispatch('setCompany', {})
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('clearNotifications')
      this.$router.push({ name: 'Login' })
    },
    openModalDetalhes() {
      if (!this.empresaSelecionada.endereco && !this.empresaSelecionada.cnae) return
      this.modalDetalhes = true
    },

    syncMenuState() {
      const body = document.querySelector('body')
      const isCollapsed = body.classList.contains('sidebar-collapse')
      this.$store.dispatch('setMenu', isCollapsed)
    }
  },

  computed: {
    empresaSelecionada: {
      get() {
        return this.$store.getters.getCompany
      },
      set(val) {}
    },
    usuarioLogado() {
      return this.$store.getters.getUser
    },

    isMenuToggled() {
      return this.$store.getters.getMenu
    },

    notifications() {
      return this.$store.getters.getNotifications
    }
  },
  watch: {
    usuarioLogado() {
      this.verificaUser()
    },
    isMenuToggled(newValue) {
      // Sincronizar o estado do DOM com o store
      const body = document.querySelector('body')
      if (newValue) {
        body.classList.add('sidebar-collapse')
      } else {
        body.classList.remove('sidebar-collapse')
      }
    }
  },
  components: {
    Popover,
    Multiselect,
    TheQueue,
    NivelLabel,
    EmpresaDetalhes,
    Modal,
    SelecaoEmpresa,
    EmpresaPendencias
  }
}
</script>

<style scoped="">
/* @media only screen and (max-width: 1600px) {
    .small-screen {
      margin-left: 60px;
    }
  } */

.main-header {
  width: 100%;
  box-shadow: 1px 3px 15px rgba(0, 0, 0, 0.6) !important;
  position: sticky;
  top: 0;
  z-index: 1030;
}

/* Correções para o sidebar toggle */
.sidebar-collapse .main-sidebar {
  transform: translate(-230px, 0);
}

.main-sidebar {
  transition: transform 0.3s ease-in-out;
}

.content-wrapper {
  transition: margin-left 0.3s ease-in-out;
}

.sidebar-collapse .content-wrapper {
  margin-left: 50px;
}

.quebra {
  white-space: normal !important;
}

.ellipsis {
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logo-lg .img-responsive {
  padding-top: 3px;
  margin: 0 auto;
}

span.logo-lg.ncm-helper {
  background-color: #3c8dbc;
  margin: 0 35px 0 0;
}

.main-header {
  background-color: #3c8dbc !important;
}

a.logo {
  padding: 0;
  max-width: 185px;
}

.hidden {
  display: none;
}

.skin-blue .main-header .logo {
  background-color: #3c8dbc;
  color: #ffffff;
  border-bottom: 0 solid transparent;
}

.logo-mini .img-responsive {
  padding-top: 3px;
  width: 45px;
  margin: 0 auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.search-on-top {
  margin-top: 4px;
  padding: 0px;
  min-width: 300px;
}

.sidebar-toggle.sidebar-left-side {
  color: #fff;
  background-color: #3c8dbc;
}

a.dropdown-toggle.user-info {
  padding: 0;
}

.hidden-xs.user {
  margin-top: 2px;
  display: block;
}

@media only screen and (max-width: 768px) {
  a.sidebar-toggle.sidebar-min-width {
    display: block;
  }

  a.logo,
  a.sidebar-toggle.sidebar-left-side {
    display: none;
  }

  .logo-lg.ncm-helper {
    background-color: #367fa9;
  }

  img.user-image {
    margin-top: 12px !important;
  }
}

@media only screen and (min-width: 768px) {
  a.sidebar-toggle.sidebar-min-width {
    display: none;
  }

  a.sidebar-toggle.sidebar-left-side {
    display: block;
  }

  img.user-image {
    margin-top: 10px !important;
  }
}
</style>

<style></style>
